import { getCurrentUser } from "@/api/permissions";

const state = {
  profile: null,
};

const getters = {
  isAdmin(state) {
    return state.profile?.roles?.includes("admin") || false;
  },
  isManager(state) {
    return state.profile?.roles?.includes("manager") || false;
  },
  isUser(state) {
    return state.profile?.roles?.includes("user") || false;
  },
  canEditApplications(state, getters) {
    return getters.isAdmin || getters.isManager;
  },
  hasAccess(state, getters) {
    return getters.isAdmin || getters.isManager || getters.isUser;
  },
  roles(state) {
    return state.profile?.roles || [];
  },
};

const mutations = {
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
};

const actions = {
  async fetchProfile({ commit }) {
    try {
      const profile = await getCurrentUser();
      commit("SET_PROFILE", profile);
    } catch {
      commit("SET_PROFILE", null);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
